import * as React from "react";
import Box from "@mui/material/Box";
import { OverViewStateCard } from "Components/OverViewStateCard";
import { AddIcon, ArrowDownIcon, LocalImage } from "Utils/images";
import { Strings } from "Utils/strings";
import { useState } from "react";
import OrdersLineCard from "Components/OrdersLineCard";
import { Colors } from "Utils/colors";
import { FrequentCustomersCard } from "Components/FrequentCustomersCard";
import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { LastTransactionCard } from "Components/LastTransactionCard";
import QuickOrderDashboard from "Components/QuickOrder";
import { Header } from "Components/Header";
import { useAppSelector } from "Hooks/reduxHook";
import { selectCurrentUser } from "Features/slice/userSlice";
import { CustomEllipticalButton } from "Components/Form";
import { useNavigate } from "react-router-dom";
import { RootState } from "Features/store";

interface IListData {
  icon: string;
  primaryLabel: string;
  secondaryLabel: string;
  teritaryLabel: string;
}

const listData: IListData[] = [
  {
    icon: LocalImage.linearMoneys,
    primaryLabel: Strings.earnings,
    secondaryLabel: "April 2022",
    teritaryLabel: "$20,129",
  },
  {
    icon: LocalImage.recentCalls,
    primaryLabel: Strings.recentCalls,
    secondaryLabel: "April 2022",
    teritaryLabel: "12",
  },
  {
    icon: LocalImage.ordersFullFilled,
    primaryLabel: Strings.orderFullFilled,
    secondaryLabel: "April 2022",
    teritaryLabel: "202",
  },
  {
    icon: LocalImage.lowRawMaterials,
    primaryLabel: Strings.lowRawMaterials,
    secondaryLabel: "April 2022",
    teritaryLabel: "2",
  },
  {
    icon: LocalImage.outOfStockItems,
    primaryLabel: Strings.outOfStockItems,
    secondaryLabel: "April 2022",
    teritaryLabel: "4",
  },
];

const ordersListData = {
  primaryLabel: "Order #54129",
  buttonLabel: "PENDING",
  secondaryLabel: "$ 17.25",
  ternaryLabel: "Today - 13:20",
};

const listFrequestCustomersData = [
  {
    avatarImage: "https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(9).webp",
    avatarLabel: "Last Transaction Date",
    middleLabel1: "Client Name",
    middleLabel2: "Last Invoice #",
    bottomLabel: "Purchase Amount",
  },
  {
    avatarImage:
      "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-profiles/avatar-1.webp",
    avatarLabel: "Last Transaction Date",
    middleLabel1: "Client Name",
    middleLabel2: "Last Invoice #",
    bottomLabel: "Purchase Amount",
  },
  {
    avatarImage: "https://mdbcdn.b-cdn.net/img/new/avatars/1.webp",
    avatarLabel: "Last Transaction Date",
    middleLabel1: "Client Name",
    middleLabel2: "Last Invoice #",
    bottomLabel: "Purchase Amount",
  },
  {
    avatarImage: "https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(9).webp",
    avatarLabel: "Last Transaction Date",
    middleLabel1: "Client Name",
    middleLabel2: "Last Invoice #",
    bottomLabel: "Purchase Amount",
  },
  {
    avatarImage:
      "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-profiles/avatar-1.webp",
    avatarLabel: "Last Transaction Date",
    middleLabel1: "Client Name",
    middleLabel2: "Last Invoice #",
    bottomLabel: "Purchase Amount",
  },
  {
    avatarImage: "https://mdbcdn.b-cdn.net/img/new/avatars/1.webp",
    avatarLabel: "Last Transaction Date",
    middleLabel1: "Client Name",
    middleLabel2: "Last Invoice #",
    bottomLabel: "Purchase Amount",
  },
];

const listFrequestCustomersData1 = [
  {
    avatarImage: "https://mdbcdn.b-cdn.net/img/new/avatars/1.webp",
    avatarLabel: "Last Transaction Date",
    middleLabel1: "Client Name",
    middleLabel2: "Last Invoice #",
    bottomLabel: "Purchase Amount",
  },
  {
    avatarImage:
      "https://coderthemes.com/hyper/saas/assets/images/users/avatar-4.jpg",
    avatarLabel: "Last Transaction Date",
    middleLabel1: "Client Name",
    middleLabel2: "Last Invoice #",
    bottomLabel: "Purchase Amount",
  },
  {
    avatarImage:
      "https://demos.themeselection.com/sneat-bootstrap-html-admin-template/documentation/assets/img/avatars/5.png",
    avatarLabel: "Last Transaction Date",
    middleLabel1: "Client Name",
    middleLabel2: "Last Invoice #",
    bottomLabel: "Purchase Amount",
  },
];

const quickOrdersListData = [
  {
    icon: LocalImage.quickOrder1,
    primaryLabel: "Mandrani Andi",
    secondaryLabel: "mandraniandi@gmail.com",
  },
  {
    icon: LocalImage.quickOrder2,
    primaryLabel: "Joshua Nunito",
    secondaryLabel: "joshuanunito@gmail.com",
  },
  {
    icon: LocalImage.quickOrder3,
    primaryLabel: "Mandrani",
    secondaryLabel: "mandrania@gmail.com",
  },
];

export default function Dashboard() {
  
  const { firstname, lastname } = useAppSelector(
    (state: RootState) => state.user.userInfo
  );

  const uName = `${firstname} ${lastname || ""}` || "Guest";

  const [selectedCard, setSelectedCard] = useState(0);
  const [overviewFilter, setOverviewFilter] = useState("Month");
  const [recentOrders, setRecentOrders] = useState("Today");

  const onCardClick = (selectedCardIndex: number) => {
    setSelectedCard(selectedCardIndex);
  };

  const handleChange = (
    event: SelectChangeEvent<any>,
    child: React.ReactNode
  ) => {
    setOverviewFilter(event.target.value);
  };

  const handleOrdersChange = (
    event: SelectChangeEvent<any>,
    child: React.ReactNode
  ) => {
    setRecentOrders(event.target.value);
  };
  const navigate = useNavigate();

  return (
    <Box
      component="main"
      sx={{
        backgroundImage: `url(${LocalImage.contactBg})`,
        backgroundRepeat: "no-repeat",
        backgroundColor: `${Colors.white}`,
        backgroundSize: "20% auto",
        backgroundPosition: "right bottom",
        flex: 1,
        overflow: "auto",
        px: 3,
        pt: 15,
        pb: 8,
      }}
    >
      <Header
        title={`${Strings.welcomeBack}, ${uName}`}
        subTitle="Let’s look at what’s happening!"
        onButtonClick={() => navigate("/invoice/createInvoice")}
      />
      <Box sx={{ display: "flex" }}>
        <Grid container>
          <Grid item sm={12} md={8}>
            <div style={{ flex: 1, marginRight: "2%" }}>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="body1"
                  component={"h6"}
                  fontSize={"14px"}
                  fontWeight={"600"}
                >
                  Overview Stats
                </Typography>
                <FormControl variant="outlined" size="small">
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={overviewFilter}
                    onChange={handleChange}
                    sx={{
                      fontSize: "12px",
                      color: Colors.textColor,
                      fontWeight: 700,
                    }}
                    IconComponent={() => (
                      <ArrowDownIcon size={24} style={{ marginRight: "8px" }} />
                    )}
                  >
                    <MenuItem value={"Week"}>Week</MenuItem>
                    <MenuItem value={"Month"}>Month</MenuItem>
                    <MenuItem value={"Year"}>Year</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div style={{ display: "flex", marginTop: "2%" }}>
                {listData?.map((item, index) => (
                  <OverViewStateCard
                    key={index.toString()}
                    currentState={
                      selectedCard === index ? "active" : "inactive"
                    }
                    icon={item.icon}
                    onClickCard={() => onCardClick(index)}
                    primaryLabel={item.primaryLabel}
                    secondaryLabel={item.secondaryLabel}
                    teritaryLabel={item.teritaryLabel}
                    containerStyle={{ marginLeft: index !== 0 ? "2%" : 0 }}
                  />
                ))}
              </div>
            </div>
          </Grid>
          <Grid item sm={12} md={4}>
            <Box sx={{ height: "350px" }}>
              <Box
                style={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingBottom: "1.5%",
                }}
              >
                <Typography
                  variant="body1"
                  component={"h6"}
                  fontSize={"14px"}
                  fontWeight={"600"}
                >
                  Recent Orders
                </Typography>
                <FormControl variant="outlined" size="small">
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={recentOrders}
                    onChange={handleOrdersChange}
                    sx={{
                      fontSize: "12px",
                      color: Colors.textColor,
                      fontWeight: 700,
                    }}
                    IconComponent={() => (
                      <ArrowDownIcon size={24} style={{ marginRight: "8px" }} />
                    )}
                  >
                    <MenuItem value={"Today"}>Today</MenuItem>
                    <MenuItem value={"Month"}>Month</MenuItem>
                    <MenuItem value={"Year"}>Year</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box
                style={{
                  maxHeight: "80%",
                  paddingTop: 3,
                  overflowY: "auto",
                }}
              >
                {new Array(4).fill(ordersListData).map((item, index) => (
                  <OrdersLineCard
                    key={index.toString()}
                    buttonLabel={item.buttonLabel}
                    primaryLabel={item.primaryLabel}
                    secondaryLabel={item.secondaryLabel}
                    ternaryLabel={item.ternaryLabel}
                    containerStyle={{ marginTop: index !== 0 ? "3%" : 0 }}
                  />
                ))}
              </Box>
              <Typography
                variant="body1"
                component={"h6"}
                color={""}
                sx={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#4EB7F2",
                  margin: "1% 0px",
                  display: "flex",
                  justifyContent: "flex-end",
                  height: "2%",
                }}
                className="clickable-text"
              >
                View All Orders
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ mt: { sm: 0, md: -10 }, display: "flex", width: "100%" }}>
        <Grid container>
          <Grid item sm={12} md={6}>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <Typography
                    variant="body1"
                    component={"h6"}
                    fontSize={"14px"}
                    fontWeight={"600"}
                    color={"#064061"}
                  >
                    Quick Order
                  </Typography>

                  <Typography
                    variant="body1"
                    component={"h6"}
                    fontSize={"12px"}
                    color={"#064061"}
                    marginTop={"4px"}
                  >
                    Latest Transaction
                  </Typography>
                </div>
                <CustomEllipticalButton
                  buttonSize="xs"
                  buttonHeight="sm"
                  label="New Invoice"
                  onBtnClick={() => navigate("/invoice/createInvoice")}
                  uppercase={false}
                  variant="contained"
                  buttonColor={Colors.secondary}
                  labelColor={Colors.white}
                  startIcon={<AddIcon color={Colors.white} size={12} />}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "2%",
                  paddingBottom: 5,
                  borderBottom: "2px solid #f1f1f1",
                }}
              >
                {quickOrdersListData?.map((item, index) => (
                  <LastTransactionCard
                    key={index.toString()}
                    icon={item.icon}
                    primaryLabel={item.primaryLabel}
                    secondaryLabel={item.secondaryLabel}
                    containerStyle={{ margin: index !== 0 ? "0px 2%" : "0px" }}
                  />
                ))}
              </div>

              <QuickOrderDashboard />
              
            </div>
          </Grid>
          <Grid item sm={12} md={6}>
            <Box
              sx={{
                ml: { sm: 0, md: 3 },
                marginTop: "8px",
              }}
            >
              <Typography
                variant="body1"
                component={"h6"}
                fontSize={"14px"}
                fontWeight={"600"}
                color={"#064061"}
              >
                Frequent Customers
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginTop: "6%",
                  gap: 10,
                }}
              >
                {listFrequestCustomersData?.map((item, index) => (
                  <FrequentCustomersCard
                    key={index.toString()}
                    avatarImage={item.avatarImage}
                    avatarLabel={item.avatarLabel}
                    middleLabel1={item.middleLabel1}
                    middleLabel2={item.middleLabel2}
                    bottomLabel={item.bottomLabel}
                  />
                ))}
              </div>
              <Typography
                variant="body1"
                component={"h6"}
                color={""}
                sx={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#4EB7F2",
                  margin: "2% 0px",
                  display: "flex",
                  justifyContent: "flex-end",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/customers/createCustomer")}
                className="clickable-text"
              >
                View All Customers
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
